import { ChevronDown } from '@carbon/icons-react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useState } from 'react';
import { colors, spacing } from '../../../utils/styleguide';
import CurrencySelectionModal from './CurrencySelectionModal';
import Flag from './Flag';

const Wrapper = styled.div`
  display: flex;
  height: ${spacing[8]}px;
  margin-bottom: ${spacing[2]}px;
`;

type CurrencyDropDownProps = {
  currencies?: { code: string; name: string }[];
  selectedCurrency?: string;
  onCurrencySelect?: (currencyCode: string) => void;
  disabled?: boolean;
  showSkeleton?: boolean;
};

const CurrencyDropDown = ({
  selectedCurrency,
  onCurrencySelect,
  currencies,
  disabled,
  showSkeleton,
}: CurrencyDropDownProps) => {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <>
      {modalOpen && (
        <CurrencySelectionModal
          selectedCurrency={selectedCurrency}
          currencies={currencies}
          onCurrencySelect={(currencyCode) => {
            onCurrencySelect && onCurrencySelect(currencyCode);
            setModalOpen(false);
          }}
          onClose={() => setModalOpen(false)}
        />
      )}
      <Wrapper>
        <button
          type="button"
          css={css`
            border: 1px solid ${colors.grey03};
            background-color: ${colors.white};
            display: flex;
            align-items: center;
            justify-content: center;
            padding: ${spacing[0]}px ${spacing[1]}px;
            cursor: pointer;
            height: 100%;
          `}
          onClick={() => setModalOpen(true)}
          aria-label="Select another currency"
          disabled={disabled || showSkeleton}
        >
          <Flag currencyCode={selectedCurrency} size="small" showSkeleton={showSkeleton} />
          {!disabled && (
            <ChevronDown size={16} color={colors.blackSecondary} css={{ marginLeft: 4 }} />
          )}
        </button>
      </Wrapper>
    </>
  );
};

export default CurrencyDropDown;
